import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const DespatchOrderListService = {
  async printOrder(payload) {
    var url = "api/Save_OrderPickingPrint";
    await ApiService.post(url, payload);
  },

  async unlockOrder(payload) {
    var url = "api/Save_SalesOrderUnlock";
    await ApiService.post(url, payload);
  },

  async lockOrder(payload) {
    var url = "api/Save_SalesOrderLock";
    await ApiService.post(url, payload);
  },

  async Save_DistributionManifest(payload) {
    var url = "api/Save_DistributionManifest/CreateFromOrders";
    return await ApiService.post(url, payload);
  }

};



export { DespatchOrderListService };
